module.exports = "<div class=\"gw-schedule-table-currency\">\r\n    <div class=\"gw-schedule-table-currency__inner\">\r\n        <gw-currency-input on-blur=\"applyNewValue\" initial-value=\"item().getValue()\" int=\"true\" currency=\"{{currency}}\"></gw-currency-input>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Currency.html
// module id = 446
// module chunks = 0